/* eslint-disable  */
//@ts-nocheck
'use strict';

import React from 'react';
import _ from 'underscore';

import helpers from './helpers';
import ExerciseEditHeader from './ExerciseEditHeader';
import NameAutocomplete from './NameAutocomplete';
import ButtonAddToLibrary from './ButtonAddToLibrary';

class YouTubeExerciseEdit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.merge = this.merge.bind(this);
    this.onToggleMinimize = this.onToggleMinimize.bind(this);
    this.linkChanged = this.linkChanged.bind(this);
    this.descriptionChanged = this.descriptionChanged.bind(this);
    this.nameChanged = this.nameChanged.bind(this);
    this.validate = this.validate.bind(this);
  }

  merge(newData) {
    let data = _.extend(this.props.data, newData);
    this.props.onChange(this.props.id, data);
  }
  onToggleMinimize() {
    if (this.props.minimizeDisabled) return;
    this.merge({ minimized: !this.props.data.minimized });
  }
  linkChanged() {
    let link = this.refs.link.value;
    if (!link) {
      this.merge({ link: '', youtubeId: null });
      return;
    }
    const isValidYTLink = helpers.validateYTURI(link);
    if (!isValidYTLink) {
      this.props.statusBar.sendMessage('Invalid Youtube link');
      this.merge({ link: '', youtubeId: null });
      return;
    }
    let youtubeId = helpers.getYouTubeId(link);
    this.merge({ link, youtubeId });
  }
  descriptionChanged(description: string) {
    this.merge({ description });
  }
  nameChanged(name) {
    this.merge({ name });
  }
  validate(attribute) {
    if (
      this.props.tree &&
      this.props.tree[attribute] &&
      this.props.tree[attribute].length > 0
    ) {
      return 'invalid';
    }
    return;
  }
  render() {
    //console.log('[YouTubeExerciseEdit] render() called.');
    // https://developers.google.com/youtube/player_parameters
    let youtubeEmbed = (
      <iframe
        type="text/html"
        src={`https://www.youtube.com/embed/${this.props.data.youtubeId}`}
        frameBorder={0}
      ></iframe>
    );
    let buttonAddToLibrary = null;
    let content = (
      <div className="workoutForm">
        <div className="trinity">
          <div className="first">
            <label>
              Exercise name<strong className="warning">*</strong>
            </label>
            <NameAutocomplete
              value={this.props.data.name}
              onChange={(e) => {
                if (e && e.name) {
                  this.nameChanged(e.name);
                }
                if (e && e.description) {
                  this.descriptionChanged(e.description);
                }
                this.nameChanged(e.name);
              }}
              placeholder="Enter exercise title"
              maxLength={60}
            />
            <label>Exercise description</label>
            <textarea
              ref="description"
              value={this.props.data.description}
              rows={3}
              cols={80}
              maxLength={1000}
              onChange={(e) => this.descriptionChanged(e.target.value)}
              placeholder="Enter description"
            />
          </div>
          <div className="second">
            <label>
              YouTube link<strong className="warning">*</strong>
            </label>
            <input
              ref="link"
              value={this.props.data.link}
              onChange={this.linkChanged}
              placeholder="Paste YouTube link here."
              maxLength={255}
              className={this.validate('link')}
            />
            {youtubeEmbed}
          </div>
        </div>
        {buttonAddToLibrary}
      </div>
    );
    return (
      <div className="youtubeExerciseEdit">
        <ExerciseEditHeader
          id={this.props.id}
          exerciseLength={this.props.exerciseLength}
          index={this.props.index}
          data={this.props.data}
          minimizeDisabled={this.props.minimizeDisabled}
          deleteDisabled={this.props.deleteDisabled}
          onToggleMinimize={this.onToggleMinimize}
          onMoveUp={this.props.onMoveUp}
          onMoveDown={this.props.onMoveDown}
          onDelete={this.props.onDelete}
        />
        {this.props.data.minimized ? '' : content}
      </div>
    );
  }
}

export default YouTubeExerciseEdit;
